export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'pharmacists_plus_admin_token',
  USER: 'pharmacists_plus_admin_user',
  PERMISSIONS: 'pharmacists_plus_admin_permissions',
  IS_SUPER_ADMIN: 'pharmacists_plus_admin_is_super_admin',
} as const;
